/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/documentdataextractor/DocumentDataExtractorUIResult.yaml
import { ToJsonConfiguration } from '../../common/JsonSerializationTypes';
import { GenericDocument } from '../../generic_document/GenericDocument';
import { ImageRef } from '../../image/image';
/**
Configuration of the generic text scanner RTU UI result.
*/
export class DocumentDataExtractorUiResult {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractorUiResult>`} */
    constructor(source = {}) {
        this._released = false;
        if (source.recognitionStatus !== undefined) {
            this.recognitionStatus = source.recognitionStatus;
        }
        else {
            throw new Error('recognitionStatus must be present in constructor argument');
        }
        if (source.document !== undefined) {
            this.document = source.document != null ? new GenericDocument(source.document) : null;
        }
        else {
            throw new Error('document must be present in constructor argument');
        }
        if (source.croppedImage !== undefined) {
            this.croppedImage = source.croppedImage != null ? ImageRef.from(source.croppedImage) : null;
        }
        else {
            throw new Error('croppedImage must be present in constructor argument');
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            recognitionStatus: this.recognitionStatus,
            document: this.document != null ? await this.document.serialize(config) : null,
            croppedImage: config.serializeImages
                ? this.croppedImage != null
                    ? await this.croppedImage.serialize(config.imageSerializationMode)
                    : null
                : undefined,
        };
    }
    release() {
        if (this._released) {
            return;
        }
        {
            if (this.document != null) {
                this.document.release();
            }
        }
        {
            if (this.croppedImage != null) {
                this.croppedImage.release();
            }
        }
        this._released = true;
    }
    async encodeImages() {
        if (this.document != null) {
            await this.document.encodeImages();
        }
        if (this.croppedImage != null) {
            await this.croppedImage.encodeInPlace();
        }
    }
}
//# sourceMappingURL=DocumentDataExtractorUiResult.js.map